module.exports = __webpack_public_path__ + "img/icon-checkmark.49ae7136.svg";